import PropTypes from 'prop-types';
import React from 'react';
import uniqueId from 'lodash/uniqueId';

import './AriaLiveRegion.scss';

function AriaLiveRegion(props) {
  const {
    children,
    id,
    offscreen,
    politeness,
  } = props;

  return (
    <div id={id} role="status" aria-live={politeness} className={offscreen ? 'hidden-accessible' : null}>
      {children}
    </div>
  );
}

AriaLiveRegion.propTypes = {
  id: PropTypes.string,
  children: PropTypes.node.isRequired,
  offscreen: PropTypes.bool,
  politeness: PropTypes.oneOf(['assertive', 'polite']),
};

AriaLiveRegion.defaultProps = {
  id: uniqueId('AriaLiveRegion_'),
  offscreen: true,
  politeness: 'polite',
};

AriaLiveRegion.displayName = 'AriaLiveRegion';

export default AriaLiveRegion;
